module.exports = __webpack_public_path__ + "static/media/addMemberGuide4_Jap.31754c57.png";